module.exports = __webpack_public_path__ + "media/images/sport--Para_Curling-f8cd7096424f3573d2292b27cef66be9.png";